import React from "react";
import { CommunicationHistoryInfoContainer } from "../../../containers";

const CommunicationHistoryInfo = (props) => {
  return <CommunicationHistoryInfoContainer {...props} />;
};

export default CommunicationHistoryInfo;
